import { cacaClient } from '@plangrid-private/web-api-clients';
import useSWR from 'swr';

import { useCurrentProjectId } from '@adsk/alloy-provider';

import { FORMS_SWR_CONFIG } from '../helpers/constants';
import { getPGProjectUsersUrl } from '../helpers/utils';

export default () => {
  const projectId = useCurrentProjectId();
  const { data, error } = useSWR(
    getPGProjectUsersUrl(projectId),
    () => {
      return cacaClient.users
        .getAllInProject(projectId)
        .then(({ users }) => users);
    },
    FORMS_SWR_CONFIG,
  );

  return {
    data,
    isError: error,
    isLoading: !error && !data,
  };
};
